import React, {Component} from "react";
import SportIcon from "../../SportIcon";
import {connect} from "react-redux";
import EditLeague from "../../../pages/LineSelect/modules/EditLeague";

class EventHeader extends Component {
	render() {
		const {sport, league} = this.props;

		console.log(league);

		return (
			<div className={`event__header`}>
				<div className="event__header-icon sport-icon white">
					<SportIcon sportId={parseInt(sport.id)}/>
				</div>
				<span>{sport.name}. {league.name}</span>


				<EditLeague league={league}/>
			</div>
		);
	}
}

export default EventHeader;


// WEBPACK FOOTER //
// ./src/app/components/EventById/Event/EventHeader.js